import React, { useEffect } from "react";
import "./style/basketTableStyle.scss";
import { BasketItem } from "../../models/BasketItem";
import BasketListItem from "./BasketItem";
import useDesktopSize from "../../../utils/hooks/useDesktopSize";
import useBasketManager from "../SaleMovie/CinemaHall/hooks/useBasketManager";
import useFinalizeManager from "./hooks/useFinalizeManager";
import { TicketAccess } from "../../models/TicketAccess";
import BasketListItemMobile from "./BasketItemMobile";
import useBasketSocks from "../SaleMovie/CinemaHall/hooks/Socks/useBasketSocks";
import useFacility from "../../../utils/hooks/useFacility";
import useKortosfera from "../SaleMovie/CinemaHall/hooks/Socks/useKortosfera";
import LoadingSpinner from "../../../features/Loading/LoadingSpinner";
import { useTranslation } from "react-i18next";
import usePCN from "../SaleMovie/CinemaHall/hooks/Socks/usePCN";
import useSrem from "../SaleMovie/CinemaHall/hooks/Socks/useSrem";

interface IProps {
  handleDelete: (index: number) => void;
  handleGetBasket: Function;
  basket: BasketItem[];
}

const BasketTable: React.FC<IProps> = ({ handleDelete, handleGetBasket, basket }: IProps) => {
  const isDesktop = useDesktopSize();
  const facilityIds = useFacility();
  const { t } = useTranslation();
  const { getBasket, checkAdditionalBasket, handleAddBasket } = useBasketManager();
  const { addKortosferaGuide } = useKortosfera();
  const { addSocks, loading } = useBasketSocks();
  const { addPCNGuide } = usePCN();
  const { addRocket } = useSrem();
  const { onRemoveItemFromBasket } = useFinalizeManager();

  useEffect(() => {
    getBasket();
    // checkAdditionalBasketPCN(basket);
    checkAdditionalBasket(basket);
    setTimeout(() => {
      if (facilityIds === "1200") {
        addSocks(basket);
      }
      if (facilityIds === "1204") {
        addSocks(basket);
      }

      if (facilityIds === "1227") {
        addSocks(basket);
      }
      if (facilityIds === "1228") {
        addKortosferaGuide(basket);
      }
      if (facilityIds === "1220") {
        addPCNGuide(basket);
      }
      if (facilityIds === "1212") {
        addRocket(basket);
      }
      
    }, 200);

    // getBasket();
    // checkAdditionalBasketPCN(basket);
    // checkAdditionalBasket(basket);
    // if (facilityIds === "1200") {
    //   console.log("addSocks");
    //   addSocks(basket);
    // }
    // if (facilityIds === "400") {
    //   addAvatarBonus(basket);
    // }
  }, []);

  // const handleDelete = (index: number) => {
  //   onRemoveItemFromBasket(index);
  //   setTimeout(() => {
  //     getBasket();
  //   }, 200);
  // };

  const handleBasketChanges = (
    assortIds: string,
    price: number,
    ticketAccess: TicketAccess | any,
    validFrom: string | null,
    qnt: number | 1
  ) => {
    handleAddBasket(assortIds, price, ticketAccess, validFrom, qnt);
    getBasket();
  };

  return (
    <React.Fragment>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <React.Fragment>
          {" "}
          {isDesktop ? (
            <React.Fragment>
              <div className={`basket-table`}>
                <div className={"basket-header flex-between-center"}>
                  <div></div>
                  <div></div>
                  <div>{t("cena")}</div>
                  <div>{t("ilosc")}</div>
                  <div>{t("wartosc")}</div>
                  <div></div>
                </div>
                {basket.map((item, index) => (
                  <div key={index} className={"basket-body"}>
                    <BasketListItem
                      item={item}
                      index={index}
                      onRemoveBasket={handleDelete}
                      handleAddBasket={handleBasketChanges}
                      handleGetBasket={handleGetBasket}
                    />
                  </div>
                ))}
              </div>
            </React.Fragment>
          ) : (
            <div className="basket-table-mobile">
              {basket.map((item, index) => (
                <div key={index} className={"basket-body"}>
                  <BasketListItemMobile
                    item={item}
                    index={index}
                    onRemoveBasket={handleDelete}
                    handleAddBasket={handleBasketChanges}
                    handleGetBasket={handleGetBasket}
                  />
                </div>
              ))}
            </div>
          )}
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default BasketTable;
